<script lang="ts" setup>
import { PhCheck } from '@phosphor-icons/vue'

import { classMerge } from '../utils/class-merge'
import { useFormField } from './use-form-field'

import type { LabelProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

const props = defineProps<LabelProps & {
  // eslint-disable-next-line vue/no-reserved-props, vue/no-unused-properties
  class?: HTMLAttributes['class']
}>()

const { valid, isTouched, formItemId } = useFormField()
</script>

<template>
  <label
    :class="classMerge(
      'flex items-center gap-1 font-button text-button-md',
      props.class
    )"
    :for="formItemId">
    <span>
      <slot />
    </span>
    <PhCheck v-if="isTouched && valid"
             weight="bold"
             class="text-positive-foreground w-4 h-4" />
  </label>
</template>
